<template>
    <div>
        <Loading v-bind:show="showLoadingHistorico">
            <PageTitle title="Benefícios - Histórico" />
            <Grid v-if="dadosAbaHistorico && $featureToggle && $featureToggle.INTEGRA_BENEFICIO_HISTORICO"
                  v-bind:Data="dadosAbaHistorico.historico"
                  v-bind:Header="headerHistorico"
                  Name="HistoricoSolicitacao"
                  Title="Histórico de Solicitação"
                  OrderBy="periodoLetivo"
                  v-bind:HeaderDetalhes="headerDetalheHistorico"
                  v-bind:DetalhesCombo1="dadosAbaHistorico.status"
                  v-bind:DetalhesCombo2="dadosAbaHistorico.ano"
                  v-bind:DetalhesCombo3="null" />
        </Loading>
    </div>
</template>
<script>
    import Grid from '@/components/Grid';
    import Beneficio from '@/services/BeneficioService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {
        name: 'BeneficioHistorico',
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
            this.beneficioService = new Beneficio(this);

                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.BeneficioHistorico) {
                        this.dadosAba = a.Beneficios;
                    }
                    else {
                        this.showLoadingHistorico = true;
                        this.dadosAba = this.historico();
                    }
                }
                else
                    this.$router.push('home');
            }

        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.BeneficioHistorico = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                showLoadingHistorico: false,
                headerHistorico: [

                    {
                        Titulo: "Descrição",
                        Field: "descricaoCompleta",
                        Width: "200px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Valor",
                        Field: "sobPercVlr",
                        Width: "120px",
                        Tipo: "moeda"
                    },

                    {
                        Titulo: "Data Início",
                        Field: "sobDataInicio",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Fim",
                        Field: "sobDataFim",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Solicitação",
                        Field: "sobDataCadastro",
                        Width: "100px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Status",
                        Field: "bsDescricao",
                        Width: "100px",
                        Tipo: "texto"
                    }
                ],
                headerDetalheHistorico: [
                    {
                        Titulo: "Observação",
                        Field: "sobObservacao",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Usuário",
                        Field: "sobUsuarioSituacao",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Tipo Lançamento",
                        Field: "tipoBolsa",
                        Tipo: "texto"
                    }
                ],

                dadosAba: null,
                dadosAbaHistorico: null
            }
        },
        methods: {
            historico() {
                if (this.$featureToggle.INTEGRA_BENEFICIO_HISTORICO) {
                    this.showLoadingHistorico = true;
                    this.beneficioService.GetHistoricoSolicitacaoBolsa({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoPeriodo: null,
                        CodigoEmpresa: this.aluno.codigoEmpresa
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAbaHistorico = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoadingHistorico = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
